//@flow

import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  SET_PAGE_LAYOUT: `${env.baseApiUrl}/ui/admin/store/page-layout`,
  GET_PAGE_LAYOUT: `${env.baseApiUrl}/ui/admin/store/page-layout`,
});

export const setPageLayoutApi = postCreator(endpoints.SET_PAGE_LAYOUT);
export const getPageLayoutApi = getCreator(endpoints.GET_PAGE_LAYOUT);
